import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import type { Transcripts } from '@trinity/chat/api/interfaces';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';

type Vars = Transcripts.StarTranscriptQuote.Request;
export type StarQuoteOptions = UseMutationOptions<Transcripts.StarTranscriptQuote.Response, AxiosResponse, Vars>;

export const useStarTranscriptQuoteMutation = (options?: StarQuoteOptions) => {

  const apiClient = useChatApiClient();

  return useMutation({
    mutationFn: (data: Vars) => {
      return apiClient.transcripts.starTranscriptQuote({
        content: data.content,
        fromTs: data.fromTs,
        toTs: data.toTs,
        transcriptId: data.transcriptId,
      });
    },
    ...options,
  });
};